/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentPlanContract
 */
export interface PaymentPlanContract {
    /**
     * Full subscription-agreement text for the plan, built from the tenant's identity, jurisdiction and the plan's minimum commitment. Single source of truth — clients must render this rather than a local copy.
     * @type {string}
     * @memberof PaymentPlanContract
     */
    text: string;
    /**
     * Minimum commitment (months) the contract text was built with.
     * @type {number}
     * @memberof PaymentPlanContract
     */
    minimum_months?: number;
}

/**
 * Check if a given object implements the PaymentPlanContract interface.
 */
export function instanceOfPaymentPlanContract(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function PaymentPlanContractFromJSON(json: any): PaymentPlanContract {
    return PaymentPlanContractFromJSONTyped(json, false);
}

export function PaymentPlanContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentPlanContract {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
        'minimum_months': !exists(json, 'minimum_months') ? undefined : json['minimum_months'],
    };
}

export function PaymentPlanContractToJSON(value?: PaymentPlanContract | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'minimum_months': value.minimum_months,
    };
}

